// extracted by mini-css-extract-plugin
export default {"content":"TitleItem_content__A9srR","fish":"TitleItem_fish__9oY9I","linkTitle":"TitleItem_linkTitle__xIUbm"};